// extracted by mini-css-extract-plugin
export var dark = "container-module--dark--12354";
export var narrow = "container-module--narrow--7658a";
export var narrower = "container-module--narrower--63d95";
export var root = "container-module--root--24733";